import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Seksjon from './Seksjon.jsx'
import SeksjonIcon from '../../../images/Seksjon.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class SeksjonList extends Component {
    state = {
        seksjoner: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getSeksjoner = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/seksjon`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                seksjoner: [...this.state.seksjoner, ...data.seksjoner].sort(this.seksjonComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }

      seksjonComparer = (a, b) => {
        if (a.seksjonsnummer == null || b.seksjonsnummer == null) return 1
        if (a.seksjonsnummer > b.seksjonsnummer) return 1
        if (a.seksjonsnummer < b.seksjonsnummer) return -1
        return 0
    }

    toggleSeksjoner = () => {
        if (this.props.antall == 0) return

        if (this.state.seksjoner.length == 0) {
            this.getSeksjoner()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    kopierSeksjoner = event => {
        event.stopPropagation()

        if (this.state.seksjoner.length == 0) return;
        const replacer = (key, value) => value === null ? '' : value
        const header = Object.keys(this.state.seksjoner[0])
        const csv = [
          header.join(','),
          ...this.state.seksjoner.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
        
        navigator.clipboard.writeText(csv)
    }   

    render() {
        const { t } = this.props
        var antallSeksjoner = this.state.continuationToken ? `${this.state.seksjoner.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleSeksjoner}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={SeksjonIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('seksjoner')} ({antallSeksjoner})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    { this.state.isOpened &&
                    <div className="icon-image right tooltip" onClick={this.kopierSeksjoner}>
                        <i className="fa fa-clipboard"></i>
                        <div className="tooltip-content">{t('vis.kopierseksjoner')}</div>
                    </div> }
                </div>
                <div className={this.state.isOpened && this.state.seksjoner.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.seksjoner.map((s, index) => {return (<Seksjon key={s.matrikkelenhetId} seksjon={s} antall={this.props.antall} isLast={index==this.state.seksjoner.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getSeksjoner}>
                                <span>{t('hent.seksjoner')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(SeksjonList)